import { render } from "./HeroiconsSolidThumbUp.vue?vue&type=template&id=5cf00f50"
const script = {}

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidThumbUp.vue"]])

export default __exports__